import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "viewpreference"
    }}>{`ViewPreference`}</h1>
    <p>{`View preferences.`}</p>
    <h2 {...{
      "id": "instance"
    }}>{`Instance`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`isValid`}</strong>{` `}</p>
      <p parentName="blockquote">{`Returns true if the object specifier resolves to valid objects.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Mixed `}<strong parentName="p">{`parent`}</strong>{` `}</p>
      <p parentName="blockquote">{`The parent of the ViewPreference (a Application or Document).`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Events `}<strong parentName="p">{`events`}</strong>{` `}</p>
      <p parentName="blockquote">{`A collection of events.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`EventListeners `}<strong parentName="p">{`eventListeners`}</strong>{` `}</p>
      <p parentName="blockquote">{`A collection of event listeners.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`pointsPerInch`}</strong>{` `}</p>
      <p parentName="blockquote">{`The number of points per inch, typically 72. (Range: 60 to 80)`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`horizontalCustomPoints`}</strong>{` `}</p>
      <p parentName="blockquote">{`The distance (in points) between major tick marks on the horizontal ruler. (Range: 4 to 256) Valid only when horizontal measurement units is custom.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`verticalCustomPoints`}</strong>{` `}</p>
      <p parentName="blockquote">{`The distance (in points) between major tick marks on the vertical ruler. (Range: 4 to 256) Valid only when vertical measurement units is custom.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`MeasurementUnits `}<strong parentName="p">{`strokeMeasurementUnits`}</strong>{` `}</p>
      <p parentName="blockquote">{`The measurement unit for stroke measurements.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`guideSnaptoZone`}</strong>{` `}</p>
      <p parentName="blockquote">{`The range (in pixels) within which an object snaps to guides. (Range: 1 to 36) Note: Snapping occurs only when guides are shown.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Measurement Unit (Number or String)=any `}<strong parentName="p">{`cursorKeyIncrement`}</strong>{` `}</p>
      <p parentName="blockquote">{`The distance to move a specified object when an arrow key is pressed. (Range depends on the measurement unit. For points: 0.001 to 100; picas: 0p0.001 to 8p4; mm: 0 to 35.278; cm: 0 to 3.5278; inches: 0 to 1.3889; ciceros: 0c0.001 to 7c9.839)`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`MeasurementUnits `}<strong parentName="p">{`horizontalMeasurementUnits`}</strong>{` `}</p>
      <p parentName="blockquote">{`The measurement unit for the horizontal ruler and other horizontally-measured spaces such as grid columns, horizontal offsets, column gutters, or others.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`MeasurementUnits `}<strong parentName="p">{`verticalMeasurementUnits`}</strong>{` `}</p>
      <p parentName="blockquote">{`The measurement unit for the vertical ruler and other vertically-measured spaces such as grid rows, vertical offsets, row heights, or others.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`RulerOrigin `}<strong parentName="p">{`rulerOrigin`}</strong>{` `}</p>
      <p parentName="blockquote">{`The default zero point at the intersection of the vertical and horizontal rulers and the scope of the horizontal ruler.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`showRulers`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, displays the horizontal and vertical rulers.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`showFrameEdges`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, displays borders of unselected frames and the diagonal lines in empty unselected frames.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`MeasurementUnits `}<strong parentName="p">{`typographicMeasurementUnits`}</strong>{` `}</p>
      <p parentName="blockquote">{`The measurement units for typography.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`MeasurementUnits `}<strong parentName="p">{`textSizeMeasurementUnits`}</strong>{` `}</p>
      <p parentName="blockquote">{`The measurement unit for text size measurements.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`MeasurementUnits `}<strong parentName="p">{`printDialogMeasurementUnits`}</strong>{` `}</p>
      <p parentName="blockquote">{`The measurement unit for the print dialog.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`showNotes`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, notes are displayed.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Object `}<strong parentName="p">{`properties`}</strong>{` `}</p>
      <p parentName="blockquote">{`A property that allows setting of several properties at the same time.`}</p>
    </blockquote>
    <h3 {...{
      "id": "methods"
    }}>{`Methods`}</h3>
    <blockquote>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`toSource`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Generates a string which, if executed, will return the ViewPreference.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`ViewPreference `}<strong parentName="p">{`getElements`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Resolves the object specifier, creating an array of object references.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`toSpecifier`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Retrieves the object specifier.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`EventListener `}<strong parentName="p">{`addEventListener`}</strong>{`( String `}<strong parentName="p">{`eventType`}</strong>{`, Mixed `}<strong parentName="p">{`handler`}</strong>{`, Boolean `}<strong parentName="p">{`captures`}</strong>{` )`}</p>
      <p parentName="blockquote">{`Adds an event listener.`}</p>
      <h4 parentName="blockquote" {...{
        "id": "parameters"
      }}>{`Parameters`}</h4>
      <table parentName="blockquote">
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Type`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Name`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Description`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`String`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`eventType`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The event type.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Mixed`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`handler`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The event handler. Can accept: File or JavaScript Function.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Boolean`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`captures`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`This parameter is obsolete. (Optional)`}</td>
          </tr>
        </tbody>
      </table>
    </blockquote>
    <hr></hr>
    <blockquote>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`removeEventListener`}</strong>{`( String `}<strong parentName="p">{`eventType`}</strong>{`, Mixed `}<strong parentName="p">{`handler`}</strong>{`, Boolean `}<strong parentName="p">{`captures`}</strong>{` )`}</p>
      <p parentName="blockquote">{`Removes the event listener.`}</p>
      <h4 parentName="blockquote" {...{
        "id": "parameters-1"
      }}>{`Parameters`}</h4>
      <table parentName="blockquote">
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Type`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Name`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Description`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`String`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`eventType`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The registered event type.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Mixed`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`handler`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The registered event handler. Can accept: File or JavaScript Function.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Boolean`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`captures`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`This parameter is obsolete. (Optional)`}</td>
          </tr>
        </tbody>
      </table>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      